import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import configs from "../../contentConfig";
import logo from "../../commonImages/logo.svg";
import { runAction } from "../../utils/actions";

const welcomeConfig = configs?.welcomePage || {};

const Welcome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("welcome-active");
    return () => document.body.classList.remove("welcome-active");
  }, []);

  return (
    <div className="welcome-page flex flex-col h-[100dvh] w-full">
      <div className="welcome-center flex-1 flex flex-col items-center justify-center gap-2 px-6">
        <img src={logo} alt="logo" className="welcome-logo" />
        {welcomeConfig.tagline && (
          <p className="welcome-tagline">{welcomeConfig.tagline}</p>
        )}
      </div>
      <div className="welcome-bottom w-full max-w-[400px] mx-auto px-6 pb-10 flex flex-col gap-3">
        {(welcomeConfig.buttons || []).map((btn, i) => (
          <button
            key={i}
            onClick={() => runAction(btn.action, navigate)}
            className={`welcome-btn welcome-btn-${btn.variant || "primary"}`}
          >
            {btn.label}
          </button>
        ))}
        {welcomeConfig.copyright && (
          <p className="welcome-copyright">{welcomeConfig.copyright}</p>
        )}
      </div>
    </div>
  );
};

export default Welcome;
